"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var Routes_1 = require("../../../constants/Routes");
var wishListSlice_1 = require("../../../features/wishList/wishListSlice");
var postSlice_1 = require("../../../features/post/postSlice");
var Logo_1 = __importDefault(require("../../Logo/Logo"));
var Button_1 = __importDefault(require("../../Button"));
var globalSlice_1 = require("../../../features/global/globalSlice");
var auth_1 = require("../../../helpers/auth");
var loginSlice_1 = require("../../../features/login/loginSlice");
var share_svg_1 = __importDefault(require("../../../../images/social-media/share.svg"));
var share_mobile_svg_1 = __importDefault(require("../../../../images/social-media/share-mobile.svg"));
var close_svg_1 = __importDefault(require("../../../../images/close.svg"));
var ShareMedia_1 = __importDefault(require("../ShareMedia"));
var react_spring_bottom_sheet_1 = require("react-spring-bottom-sheet");
var useDeviceResize_1 = require("../../../hooks/useDeviceResize");
var useToggleDomElementStyle_1 = __importDefault(require("../../../hooks/useToggleDomElementStyle"));
var searchResultSlice_1 = require("../../../features/SearchResult/searchResultSlice");
var usePrevious_1 = require("../../../hooks/usePrevious");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TopBar = function (_a) {
    var isPreview = _a.isPreview, postData = _a.postData, postId = _a.postId;
    var dispatch = react_redux_1.useDispatch();
    var history = react_router_dom_1.useHistory();
    var t = react_i18next_1.useTranslation('common').t;
    var bookMarkLoading = react_redux_1.useSelector(wishListSlice_1.wishlistLoadingSelector);
    var isLoginSuccess = react_redux_1.useSelector(loginSlice_1.selectIsLoginSuccess);
    var previousIsLoginSuccess = usePrevious_1.usePrevious(isLoginSuccess);
    var _b = react_1.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var mobileResize = useDeviceResize_1.useDeviceResize(useDeviceResize_1.MediaQueries.mobile);
    useToggleDomElementStyle_1.default(isOpen);
    react_1.useEffect(function () {
        if (isLoginSuccess &&
            previousIsLoginSuccess === false &&
            auth_1.isAuthenticated()) {
            dispatch(searchResultSlice_1.getBookmarkedIds());
            dispatch(postSlice_1.getPost(postId));
        }
    }, [isLoginSuccess]);
    var isNotPublished = react_1.useMemo(function () { return isPreview && !postData.publish_date; }, [isPreview, postData.publish_date]);
    var publish = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(postSlice_1.publishPost(postId))];
                case 1:
                    _b.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('POST_SCREEN.PUBLISH_SUCCESS'),
                        appearance: 'success',
                    }));
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('POST_PREVIEW.INVALID_POST'),
                        appearance: 'error',
                    }));
                    history.push("/announcement/" + postId);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleBookMarkClick = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    e.preventDefault();
                    if (!auth_1.isAuthenticated()) return [3 /*break*/, 5];
                    dispatch(postSlice_1.toggleBookmarked());
                    if (!postData.bookmarked) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(wishListSlice_1.removeBookmark(postId))];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, dispatch(wishListSlice_1.addBookmark(postId))];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    _a;
                    dispatch(searchResultSlice_1.getBookmarkedIds());
                    return [3 /*break*/, 6];
                case 5:
                    dispatch(loginSlice_1.openLoginFormModal({ redirectAfterLogin: false }));
                    _b.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "top-bar" },
        react_1.default.createElement(Logo_1.default, null),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.actions_box },
            isPreview && (react_1.default.createElement(react_router_dom_1.Link, { to: "/" + Routes_1.Routes.EditAnnouncement.name + "/" + postId },
                react_1.default.createElement("i", { className: "cm-icon icon-ic-edit" }))),
            isNotPublished && (react_1.default.createElement("div", { className: styles_module_scss_1.default.actions_group },
                react_1.default.createElement(Button_1.default, { onClick: publish }, t('POST_PREVIEW.PUBLISH'))))),
        !isPreview && (react_1.default.createElement("ul", { className: "actions" },
            react_1.default.createElement("li", null,
                react_1.default.createElement("a", { href: "#", onClick: function (e) {
                        return !bookMarkLoading && handleBookMarkClick(e);
                    }, className: classnames_1.default({
                        active: postData.bookmarked,
                    }) },
                    react_1.default.createElement("i", { className: "icon-favorites" }),
                    !postData.bookmarked && (react_1.default.createElement("span", null, t('POST_PREVIEW.SAVE'))))),
            react_1.default.createElement("li", null, !mobileResize ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.desktopShare },
                react_1.default.createElement("span", { className: styles_module_scss_1.default.share },
                    react_1.default.createElement("img", { className: styles_module_scss_1.default.shareIcon, src: share_svg_1.default }),
                    t('POST_PREVIEW.SHARE')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.boxOnHover },
                    react_1.default.createElement(ShareMedia_1.default, null)))) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.mobileShare },
                react_1.default.createElement("img", { className: styles_module_scss_1.default.mobileShareIcon, src: share_mobile_svg_1.default, onClick: function () { return setIsOpen(true); } }),
                react_1.default.createElement(react_spring_bottom_sheet_1.BottomSheet, { open: isOpen, onDismiss: function () { return setIsOpen(false); }, snapPoints: function (_a) {
                        var minHeight = _a.minHeight;
                        return minHeight;
                    } },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.close, onClick: function () { return setIsOpen(false); } },
                        react_1.default.createElement("img", { src: close_svg_1.default })),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.infoHeader },
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.logo }),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.info },
                            react_1.default.createElement("span", { className: styles_module_scss_1.default.banaliText }, 'banali.am'),
                            postData.isDeveloper && (react_1.default.createElement("span", { className: styles_module_scss_1.default.postName }, '"' +
                                postData.sections
                                    .about_building
                                    .building_name +
                                '"')))),
                    react_1.default.createElement("hr", { className: styles_module_scss_1.default.divider }),
                    react_1.default.createElement(ShareMedia_1.default, null)))))))));
};
exports.default = react_1.memo(TopBar);
